import React, { useEffect, useState } from "react";
import { Dropdown, Modal } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import { GrFormPrevious } from "react-icons/gr";
import { MdOutlineNavigateNext } from "react-icons/md";
import "../css/pagination.css";
import moment from "moment/moment";
// import { useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Server2 } from "../../redux/actions/auth/auth.actions";
import { BsCaretDownFill } from "react-icons/bs";
import { useSelector } from "react-redux";

const PER_PAGE = 25;

const Disputes = () => {
  const [Data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const userData = useSelector((state) => state?.auth?.user?.user);
  const [LikesPopup, setDetPopup] = useState({index: 0, type: false, dispute: null});
  // const userData = useSelector((state) => state?.auth?.user?.user);
  // const navigate = useNavigate();
  const [q, setQ] = useState("");
  const list = [
    "open",
    "seller_responded",
    "under_review",
    "resolved_refund",
    "resolved_release",
    "rejected",
  ];

  function searchData() {

    return Data.filter((user) => {
      if (q === "") {
        return user;
      } else if (user?.status.toLowerCase().includes(q.toLowerCase())) {
        return user;
      } else return user;
    });
  }
  const fetchRequests = () => {
    let config = {
      method: "post",
      url: Server2 + "/admin/get-disputes",
      data: {
        id: userData._id
      },
    };
    axios(config)
      .then(function (response) {
        setLoading(false);
        console.log(response.data);
        response.data.sort(
          (b, c) => new Date(c.createdAt) - new Date(b.createdAt)
        );
        setData(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  // API'S Approved request
  const updateDispute = (e, action) => {
    const data = {
      id: e,
      action
    };
    let config = {
      method: "post",
      url: Server2 + "/admin/update-dispute",
      data: data,
    };

    axios(config)
      .then(function (response) {
        fetchRequests();
        console.log(response.data, "i am res---");
      })
      .catch(function (error) {
        console.log(error, "error Dispute Update");
      });
  };

  useEffect(() => {	
    setLoading(true);
    fetchRequests();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  //pagination function
  function handlePageClick({ selected: selectedPage }) {
    setCurrentPage(selectedPage);
  }

  const splitTwo = (str) => {
    return str.split('_').length < 2 ? str : str.split('_')[0] + " " + str.split('_')[1]
  }

  //pagination
  const offset = currentPage * PER_PAGE;
  const currentPageData = Data.length === 0 ? null : searchData().slice(offset, offset + PER_PAGE).map((dispute, index) => (
            <tbody key={index}>
              <tr>
                <td>
                  <div className="d-flex px-2 py-1">
                    <div>
                      <img
                        src={
                          dispute.buyer.profile_pic
                            ? dispute.buyer.profile_pic
                            : "/img/upload-photo.png"
                        }
                        className="avatar avatar-sm me-2"
                        alt="user1"
                      />
                    </div>
                    <div className="d-flex flex-column justify-content-center">
                      <h6 className="mb-0 text-sm text-capitalize ">
                        {dispute.buyer.fname}
                      </h6>
                      <p className="text-xs text-secondary mb-0">
                        {dispute.buyer.email}
                      </p>
                    </div>
                  </div>
                </td>
                <td>
                {dispute.products.map(product => (
                  <div className="d-flex px-2 py-1">
                    <div>
                      <img
                        src={
                          product.image
                            ? product.image
                            : "/img/upload-photo.png"
                        }
                        className="avatar avatar-sm me-2 rounded-1"
                        alt="user1"
                      />
                    </div>
                    <div className="d-flex flex-column justify-content-center">
                      <h6 className="mb-0 text-sm text-capitalize ">
                        {product.productName}
                      </h6>
                      <p className="text-xs text-secondary mb-0">
                        By: {dispute.seller.fname}
                      </p>
                    </div>
                  </div>
                ))}
                </td>
                <td className="align-middle">
                  {dispute.reason}
                </td>
                <td className="align-middle text-center">
                  <span
                    className={`badge badge-sm ${
                        dispute.status === "open" ? "bg-gradient-warning"
                      : dispute.status === "seller_responded" ? "bg-gradient-primary"
                      : dispute.status === 'resolved_refund' || dispute.status === 'resolved_released' ? "bg-gradient-success" 
                      : "bg-gradient-danger"
                    }`}
                  >
                    {splitTwo(dispute.status)}
                  </span>
                  {/* <div>
                    <h6 className="lh-1 pt-1" style={{ pointer: "cursor", maxWidth: 270, textOverflow: 'ellipsis', overflowX: 'hidden' }} title={dispute.sellerResponse?.message}>
                      {dispute.sellerResponse?.message ? dispute.sellerResponse.message : "-"}
                    </h6>
                  </div> */}
                </td>
                <td className="align-middle">
                  <p>
                    {moment(dispute.createdAt).format("MMMM Do, YYYY  h:mm A")}
                  </p>
                </td>
                <td className="align-middle">
                  <div className="d-flex justify-content-center">
                    {/* <Button style={{ background: '#6148a1', border: 'none' }} onClick={() => handelAprovedRequest(user)}></Button> */}
                    <Dropdown className="border-0 rounded-2 add-btn fw-bold">
                      <Dropdown.Toggle
                        className="border-0"
                        id="dropdown-basic"
                        aria-expanded="false"
                        style={{ backgroundColor: "#6148a1" }}
                      >
                        <button
                          type="button"
                          className="bg-transparent border-0 text-white"
                          data-bs-toggle="button"
                        >
                          <spam className="d-inline postition-relative text-white">
                            Take Action
                          </spam>
                        </button>
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="w-100 text-center">
                        <Dropdown.Item
                          eventKey="4"
                          onClick={() => setDetPopup({type: true, index: index, dispute: dispute})}
                          style={{ fontSize: 13 }}
                        >
                          View Response
                        </Dropdown.Item>
                        {/* <Dropdown.Item
                          eventKey="1"
                          onClick={() => updateDispute(dispute?._id, 'refund')}
                          style={{ fontSize: 13 }}
                          >
                          Mark Refunded
                        </Dropdown.Item> */}
                        <Dropdown.Item
                          eventKey="2"
                          onClick={() => updateDispute(dispute?._id, 'release')}
                          style={{ fontSize: 13 }}
                        >
                          Mark Released
                        </Dropdown.Item>
                        <Dropdown.Item
                          eventKey="3"
                          onClick={() => updateDispute(dispute?._id, 'reject')}
                          style={{ fontSize: 13 }}
                        >
                          Reject Dispute
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </td>
              </tr>
            </tbody>
          ));

  const pageCount = Math.ceil(searchData().length / PER_PAGE);

  return (
    <>
      {loading ? (
        <div className="d-flex justify-content-center align-items-center">
          <div
            className="spinner-border"
            role="status"
            style={{ width: "6rem", height: "6rem", color: "#6148A1" }}
          >
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      ) : (
        <>
          <div className="container-fluid ">
            <div className="row">
              <div className="col-12">
                <div className="card mb-4">
                  <div className="card-header pb-0">
                    <h6>Disputes</h6>
                  </div>
                  <div
                    className="card-body px-0 pt-0 pb-2 task"
                    style={{ height: "73vh", overflow: "auto" }}
                  >
                    <div className="table-responsive p-0">
                      <table className="table align-items-center mb-0">
                        <thead>
                          <tr>
                            <th className="text-uppercase">Buyer</th>
                            <th className="text-uppercase">Product(s)</th>
                            <th className="text-uppercase">Reason</th>
                            <th className="">
                              <Dropdown className="">
                                <Dropdown.Toggle
                                  className=" border-0"
                                  variant=""
                                  id="dropdown-basic"
                                  aria-expanded="false"
                                >
                                  <span
                                    className="fs-6 fw-bold text-uppercase"
                                    style={{ color: "#67748e" }}
                                  >
                                    Status{" "}
                                    <BsCaretDownFill size={12}/>
                                  </span>
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="dropdown-menu">
                                <Dropdown.Item
                                  onClick={() => {
                                    setQ("");
                                  }}
                                >
                                  <span className="fw-bold">
                                    All Requests
                                  </span>
                                </Dropdown.Item>
                                  {
                                    list.map((e) =>{
                                      return(
                                          <Dropdown.Item
                                          onClick={() => {
                                            setQ(e);
                                          }}
                                        >
                                          <span className="fw-bold">
                                            {e}
                                          </span>
                                        </Dropdown.Item>
                                      )
                                    })
                                  }
                                </Dropdown.Menu>
                              </Dropdown>
                            </th>
                            <th className=" text-uppercase ps-5">
                              Last Processed
                            </th>
                            <th className="text-uppercase text-center">
                              Actions
                            </th>
                          </tr>
                        </thead>
                        {currentPageData}
                      </table>
                    </div>

                    {searchData().length > 24 ? (
                      <div
                        className=" mt-4"
                        style={{
                          padding: 2,
                          boxSizing: "border-box",
                          width: "100%",
                        }}
                      >
                        <ReactPaginate
                          activeClassName={"item active "}
                          breakClassName={"item break-me "}
                          breakLabel={"..."}
                          containerClassName={"pagination"}
                          t
                          disabledClassName={"disabled-page"}
                          marginPagesDisplayed={2}
                          nextClassName={"item next "}
                          nextLabel={
                            <MdOutlineNavigateNext
                              style={{ fontSize: 18, width: 150 }}
                            />
                          }
                          onPageChange={handlePageClick}
                          pageCount={pageCount}
                          pageClassName={"item pagination-page "}
                          pageRangeDisplayed={2}
                          previousClassName={"item previous"}
                          previousLabel={
                            <GrFormPrevious
                              style={{ fontSize: 18, width: 150 }}
                            />
                          }
                        />
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Modal
            show={LikesPopup.type}
            onHide={() => setDetPopup({type: false, index: null, dispute: ''})}
            backdrop="static"
            keyboard={false}
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title style={{fontSize: 20}}>{LikesPopup.dispute?.seller?.fname}'s Response</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="d-flex flex-column">
                <p className="text-dark fs-6">{LikesPopup.dispute?.sellerResponse ? LikesPopup.dispute.sellerResponse.message : `Not Response Yet` }</p>
              </div>
            </Modal.Body>
            {/* <Modal.Footer>
              <Button variant="secondary" onClick={reportPost()}>
                Submit
              </Button>
            </Modal.Footer> */}
          </Modal>
        </>
      )}
    </>
  );
};

export default Disputes;